import React, { useContext, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { ContentContext } from './components/content/ContentContext';
import Forum from './pages/Forum';
import { useUser } from './components/loggedUserContext/LoggedUserContext';

const AppRoutes = () => {
  const { setSelectedPostId, setContent } = useContext(ContentContext);
  const { setUserId } = useUser();  // Ensure setUserId is destructured correctly
  const navigate = useNavigate();

  useEffect(() => {
    // Extract postId and userId from URL
    const queryParams = new URLSearchParams(window.location.search);
    const postIdFromUrl = queryParams.get('postId');
    const userIdFromUrl = queryParams.get('userId');

    if (process.env.NODE_ENV === "development" && userIdFromUrl) {
      console.log('Setting userId from URL:', userIdFromUrl);
      setUserId(userIdFromUrl);
    }

    if (postIdFromUrl) {
      // Set the postId in context
      setContent("PostDetails");
      setSelectedPostId(postIdFromUrl);

      // Remove the postId from the query parameters
      queryParams.delete('postId');

      // Construct the new URL with the remaining parameters
      const newUrl = `${window.location.pathname}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

      console.log('newUrl', newUrl);
      // Navigate to the new URL without the postId parameter
      navigate(newUrl, { replace: true });
    }

    // Clean up the userId from the query parameters if needed
    queryParams.delete('userId');

  }, [navigate, setContent, setSelectedPostId, setUserId]); // Include setUserId in dependencies

  return (
    <>
      <Forum />
    </>
  );
};

export default AppRoutes;
